// extracted by mini-css-extract-plugin
export default {"root":"nENfys53rIw720sSeYuf","text":"TVsyqWbcjisNmU0vY8xQ","clickable":"M_ufqJwotUcjjghSh7bo"};